<template>
  <Report :product="product" isDetailsVisible>
    <template v-slot:callToAction>
      <BuyReportAboutPerson
        :product="product"
        @buy="buy"
        :user="user"
        class="d-none d-md-block"
      />
    </template>

    <template v-slot:default>
      <BuyReportAboutPerson
        :product="product"
        @buy="buy"
        class="d-md-none"
      />
      <BTabs nav-class="small-tabs d-print-none" content-class="structure-tabs">
        <BTab title-item-class="max-width-sm" title-link-class="flex-column align-items-start no-click">
          <template v-slot:title>
            <span class="marker icon-arrow-down3" />
            <h2>{{ $t('report.sample') }}</h2>
            <span class="nav-head-subtext">{{ product.sampleHint }}</span>
          </template>
          <template v-slot:default>
            <div class="tab-container-medium">
              <Watermark :text="product.watermarkLabel" />
              <SampleReport :name="product.productCode" />
            </div>
          </template>
        </BTab>
      </BTabs>
    </template>
  </Report>
</template>

<script>
import SampleReport from './SampleReport';
import Report from './Report';
import BuyReportAboutPerson from './BuyReportAboutPerson';
import Watermark from './Watermark';
import { BTab, BTabs } from 'bootstrap-vue-next';

export default {
  props: {
    product: { type: Object, required: true },
    user: Object,
  },
  components: {
    BTabs,
    BTab,
    Report,
    BuyReportAboutPerson,
    SampleReport,
    Watermark,
  },
  methods: {
    buy(item) {
      this.$emit('buy', item);
    },
  },
};
</script>
